import React from 'react';
import RelatedWrapper from '../related';

const namespace = 'ui-pdp-related-search';

const RelatedSearches = props => <RelatedWrapper {...props} namespace={namespace} />;

export default RelatedSearches;
